<template>
  <section class="gf-user-followers-counter">
    <span class="gf-user-followers-counter__counter">
      <i class="gf-icon gf-icon-user-add mr-2"></i>
      <a :href="`/user/${username}/followers`">
        {{ followersCount }}
        {{ $pluralize(parseInt(followersCount), $t('profile.followers.counted')) }}
      </a>
    </span>
    <span class="gf-user-followers-counter__counter">
      <i class="gf-icon gf-icon-eye mr-2"></i>
      <a :href="`/user/${username}/subscriptions`">
        {{ subscriptionsCount }}
        {{ $pluralize(parseInt(subscriptionsCount), $t('profile.subscriptions.counted')) }}
      </a>
    </span>
  </section>
</template>

<script>
import ProfileMessages from '@shared/modules/profile/profile.messages';

export default {
  name: 'GfUserFollowersCounter',
  props: {
    followersCount: {
      default: 0
    },
    subscriptionsCount: {
      default: 0
    },
    username: {
      type: String,
      default: null
    }
  },
  i18n: {
    messages: ProfileMessages
  }
};
</script>

<style lang="scss">
$this: '.gf-user-followers-counter';

#{$this} {
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  gap: 4px;

  @include theme.sm {
    flex-direction: row;
    gap: 12px;
  }

  #{$this}__counter {
    text-wrap: nowrap;

    & > a {
      color: var(--text);
    }
  }
}
</style>
